 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLHALFTITLE from '@/components/xhtml/Halftitle'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLILLUSTRATIONS from '@/components/xhtml/Illustrations'
 import XHTMLABBREVIATIONS from '@/components/xhtml/Abbreviations'
 import XHTMLINTRODUCTION from '@/components/xhtml/Introduction'
 import XHTMLCHAPTER01 from '@/components/xhtml/Chapter01'
 import XHTMLCHAPTER02 from '@/components/xhtml/Chapter02'
 import XHTMLCHAPTER03 from '@/components/xhtml/Chapter03'
 import XHTMLCHAPTER04 from '@/components/xhtml/Chapter04'
 import XHTMLCHAPTER05 from '@/components/xhtml/Chapter05'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLNOTES from '@/components/xhtml/Notes'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/Bibliography'
 import XHTMLFILMOGRAPHY from '@/components/xhtml/Filmography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/Dedication",
 			"name" : "xhtml/Dedication",
 			"component" : XHTMLDEDICATION
 		},
 		{
 			"path" : "/xhtml/Illustrations",
 			"name" : "xhtml/Illustrations",
 			"component" : XHTMLILLUSTRATIONS
 		},
 		{
 			"path" : "/xhtml/Abbreviations",
 			"name" : "xhtml/Abbreviations",
 			"component" : XHTMLABBREVIATIONS
 		},
 		{
 			"path" : "/xhtml/Introduction",
 			"name" : "xhtml/Introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/Chapter01",
 			"name" : "xhtml/Chapter01",
 			"component" : XHTMLCHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js